import { createFileRoute } from '@tanstack/react-router';

import { sessionQueries } from '@/api';
import { WatchlistPage } from '@/features/watchlist/watchlist-page';

/*
  Каркас робочої зони, але БЕЗ охорони входу: список живе в localStorage і
  доступний гостю навмисно — збережене до реєстрації не має зникати за
  екраном входу.

  `beforeLoad` тут нічого не забороняє, лише чекає на відповідь про сесію:
  від неї залежить, який каркас малює корінь, і без цього кроку сторінка
  встигала блимнути не тим.
*/
export const Route = createFileRoute('/watchlist')({
	beforeLoad: async ({ context }) => {
		await context.queryClient.ensureQueryData(sessionQueries.current());
	},
	component: WatchlistPage,
	staticData: { workspace: true },
});
